<template>
  <div>
    <index-card :loading="loading">
      <template slot="header">
        <div class="d-flex align-center">
          <v-btn text icon large to="/" exact><v-icon class="white--text">mdi-arrow-left</v-icon></v-btn>

          <v-btn 
            color="white" class="ml-1 blue-grey--text elavation-0 font-weight-bold" 
            :to="{name: create_redirect_to, params: {solution: this.$route.params.solution}}" 
          ><v-icon left>mdi-plus</v-icon>ADICIONAR {{ solution_map[$route.params.solution] }}</v-btn>

        </div>
        <div class="headline white--text">
          {{ solution_map[$route.params.solution] }}
          <v-icon class="white--text">mdi-domain</v-icon>
        </div>
      </template>
      <template slot="subheader">
        <div class="modality-index-filters">
          <filter-data
            :with_client="false"
            :with_date_start="false"
            :with_date_end="false"
            with_text_search
            text_search_label="Encontrar"
            :loading_block="loading"
            @doneFilter="handleDoneFilter"
          />
        </div>
      </template>
      <template slot="data_table">
        <v-data-table class="elevation-4" mobile-breakpoint="1" :items="all_modalities" :headers="modalities_list_header" :loading="loading" :search="search">
          <template v-slot:item.actions="{ item }">
            <v-btn :to="{name: show_redirect_to, params: {...$route.params, id: item.id}}" color="primary" dark small icon><v-icon>mdi-pencil</v-icon></v-btn>
          </template>
        </v-data-table>
      </template>
    </index-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ModalityIndex',
  components:{
    IndexCard: () => import("@/_backoffice/_registrations/components/shared/index/IndexCard.vue"),
    FilterData: () => import('@/components/shared/FilterData.vue'),
  },
  data() {
    return {
      search: '',
      loading: true,
      modalities_list_header: [
        { text: 'Nome', value: 'name', width: '85%' },
        { text: 'Ações', value: 'actions'}
      ],
      solution_map: {
        'retail': 'Galpão',
        'wholesale': 'Grandes Cargas',
      }

    }
  },
  mounted () {
    this.indexAllModalities({params: {solution: this.$route.params.solution}}).then(r=>{
      this.loading = false
    })
  },
  methods: {
    handleDoneFilter(filter = {}) {
      this.search = filter.query ? String(filter.query) : ''
    },
    ...mapActions({
      indexAllModalities: 'Modality/index',
    }),
  },
  computed: {
    show_redirect_to(){
      if (this.$route.params.solution.includes('retail')) return 'ShowModalityRegister'
      if (this.$route.params.solution.includes('wholesale')) return 'ShowModalityRegisterWholesale'
    },
    create_redirect_to(){
      if (this.$route.params.solution.includes('retail')) return 'ModalityRegister'
      if (this.$route.params.solution.includes('wholesale')) return 'ModalityRegisterWholesale'
    },

    ...mapState({
      all_modalities: state => state.Modality.all_modalities,
    })
  },
  beforeCreate () {
    if(!this.$route.params.solution){
      this.$router.push({name: 'Home'})
    };
  },
}
</script>

<style lang="scss" scoped>
.modality-index-filters {
  width: 100%;
  flex: 1 1 100%;
  min-width: 0;
}
.modality-index-filters ::v-deep .filter-data-card {
  width: 100%;
}
</style>
